import { InMemoryCache } from '@apollo/client'

const cache = new InMemoryCache({
  typePolicies: {
    ShopCart: {
      fields: {
        availablePickupLocations: {
          merge: false,
        },
        cartItems: {
          merge: false,
        },
      },
    },
  },
  // NOTE: https://github.com/apollographql/apollo-client/issues/6632
  possibleTypes: {
    OperatingDayInterface: ['OperatingDayCalendar', 'OperatingDaySpecial', 'OperatingDayWeekly'],
    ShopCartFulfillmentDeliverySetting: [
      'ShopCartFulfillmentDoorDashDeliverySetting',
      'ShopCartFulfillmentInHouseDeliverySetting',
      'ShopCartFulfillmentUberDeliverySetting',
      'ShopCartFulfillmentJustEatDeliverySetting',
    ],
    ShopCartFulfillmentScheduleSettingInterface: [
      'ShopCartFulfillmentDeliverySetting',
      'ShopCartFulfillmentDoorDashDeliverySetting',
      'ShopCartFulfillmentJustEatDeliverySetting',
      'ShopCartFulfillmentUberDeliverySetting',
      'ShopCartFulfillmentInHouseDeliverySetting',
      'ShopCartFulfillmentPickupSetting',
      'ShopCartFulfillmentTableSetting',
    ],
  },
})

export default cache
